import React from "react";
import { XMarkIcon, ArrowUpTrayIcon } from "@heroicons/react/24/outline";
import { Folder } from "../types";

interface MoveFolderModalProps {
  show: boolean;
  onClose: () => void;
  movingFolder: Folder | null;
  moveTargetFolderId: number | null;
  setMoveTargetFolderId: (id: number | null) => void;
  flattenedFolders: Array<{ id: number; name: string; depth: number }>;
  excludedMoveFolderIds: Set<number>;
  onMove: () => void;
}

const MoveFolderModal: React.FC<MoveFolderModalProps> = ({
  show,
  onClose,
  movingFolder,
  moveTargetFolderId,
  setMoveTargetFolderId,
  flattenedFolders,
  excludedMoveFolderIds,
  onMove,
}) => {
  if (!show) return null;

  return (
    <div className="fixed inset-0 overflow-y-auto z-50">
      <div className="flex items-center justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
        <div
          className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity"
          aria-hidden="true"
          onClick={onClose}
        ></div>

        <span
          className="hidden sm:inline-block sm:align-middle sm:h-screen"
          aria-hidden="true"
        >
          &#8203;
        </span>

        <div className="inline-block align-bottom bg-white rounded-2xl text-left overflow-hidden shadow-2xl transform transition-all sm:my-8 sm:align-middle sm:max-w-md sm:w-full">
          <div className="bg-gradient-to-r from-blue-600 to-indigo-600 px-6 py-4 flex items-center justify-between">
            <h3 className="text-xl font-bold text-white flex items-center">
              <ArrowUpTrayIcon className="h-6 w-6 mr-2" />
              ຍ້າຍໂຟລເດີ: {movingFolder?.name}
            </h3>
            <button
              onClick={onClose}
              className="text-white hover:text-gray-200 transition-colors"
            >
              <XMarkIcon className="h-6 w-6" />
            </button>
          </div>

          <div className="px-6 py-6 space-y-4">
            <p className="text-sm text-gray-600">ເລືອກໂຟລເດີປາຍທາງ:</p>
            <select
              value={moveTargetFolderId === null ? "" : moveTargetFolderId}
              onChange={(e) =>
                setMoveTargetFolderId(
                  e.target.value === "" ? null : parseInt(e.target.value),
                )
              }
              className="w-full px-4 py-2.5 border border-gray-300 rounded-xl focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all duration-200 shadow-sm"
              title="Select destination folder"
            >
              <option value="">-- ໜ້າຫຼັກ (Root) --</option>
              {flattenedFolders
                .filter((f) => !excludedMoveFolderIds.has(f.id))
                .map((folder) => (
                  <option key={folder.id} value={folder.id}>
                    {"\u00A0".repeat(folder.depth * 2)}
                    {folder.depth > 0 ? "└ " : ""}
                    {folder.name}
                  </option>
                ))}
            </select>

            <div className="flex justify-end space-x-3 pt-4">
              <button
                type="button"
                onClick={onClose}
                className="px-6 py-2.5 border border-gray-300 rounded-xl text-sm font-semibold text-gray-700 bg-white hover:bg-gray-50 transition-all duration-200 shadow-sm"
              >
                ຍົກເລີກ
              </button>
              <button
                onClick={onMove}
                className="px-8 py-2.5 rounded-xl text-sm font-bold text-white bg-gradient-to-r from-blue-600 to-indigo-600 hover:from-blue-700 hover:to-indigo-700 shadow-lg hover:shadow-xl active:scale-95 transition-all duration-200"
              >
                ຍ້າຍໂຟລເດີ
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MoveFolderModal;
